// extracted by mini-css-extract-plugin
export default {"mCard":"AB-z","image":"BB-z","imageNoBackground":"CB-z","imageHasCategory":"DB-z","fullWidth":"EB-z"};